import { render } from "./Indicator.vue?vue&type=template&id=b5d2bed2"
import script from "./Indicator.vue?vue&type=script&lang=ts"
export * from "./Indicator.vue?vue&type=script&lang=ts"
script.render = render

export default script